module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/login/login.component.html
// module id = ./src/app/modules/login/login.component.html
// module chunks = main